import { motion } from "framer-motion";
import { Clock, ArrowUpDown, Coins, AlertTriangle } from "lucide-react";

const InvestmentPlanSection = () => {
  return (
    <section id="plans" className="relative py-24 overflow-hidden">
      {/* Background Video with Blur */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="h-full w-full object-cover blur-sm scale-105"
        >
          <source src="/videos/investment-plan.mov" type="video/quicktime" />
          <source src="/videos/investment-plan.mov" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-background/70" />
      </div>
      <div className="container relative z-10 mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="font-display text-3xl font-bold gradient-gold-text md:text-4xl">Investment Plan</h2>
          <p className="mt-4 text-muted-foreground font-body">One strategic plan. Maximum returns.</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mx-auto mt-12 max-w-lg"
        >
          <div className="relative overflow-hidden rounded-2xl border border-gold/40 bg-card glow-gold">
            {/* Header */}
            <div className="gradient-gold px-8 py-6 text-center">
              <h3 className="font-display text-xl font-bold text-primary-foreground">7-Day Crypto Trading Cycle</h3>
            </div>

            {/* Body */}
            <div className="space-y-5 p-8">
              <div className="flex items-center gap-3">
                <ArrowUpDown className="h-5 w-5 text-gold" />
                <div>
                  <p className="text-sm text-muted-foreground">Deposit Range</p>
                  <p className="font-display text-lg font-semibold text-foreground">£1,000 – £10,000</p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <Coins className="h-5 w-5 text-gold" />
                <div>
                  <p className="text-sm text-muted-foreground">Estimated Return</p>
                  <p className="font-display text-lg font-semibold text-gold">5% – 15% Guaranteed</p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <Clock className="h-5 w-5 text-gold" />
                <div>
                  <p className="text-sm text-muted-foreground">Cycle Duration</p>
                  <p className="font-display text-lg font-semibold text-foreground">7 Days</p>
                </div>
              </div>

              <div className="rounded-lg border border-gold-dark/30 bg-secondary/50 p-4 text-center">
                <p className="text-sm text-muted-foreground">Capital & Profits Returned After 7 Days</p>
                <p className="mt-1 font-display text-sm font-semibold text-gold">BTC • USDT • BNB Deposits Only</p>
              </div>
            </div>

            {/* Disclaimer */}
            <div className="border-t border-gold-dark/20 px-8 py-4">
            <div className="flex items-start gap-2">
                <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-gold/70" />
                <p className="text-xs text-muted-foreground font-body">
                  Capital & profits are returned at the end of each 7-day trading cycle.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default InvestmentPlanSection;
